import { useLocation } from 'react-router-dom';
import { Header } from './Header';

interface ConditionalHeaderProps {
  onGetStarted: () => void;
}

export function ConditionalHeader({ onGetStarted }: ConditionalHeaderProps) {
  const location = useLocation();
  // List of routes where the global header should be hidden
  const hiddenRoutes = [
    '/odisha-industry-landing', 
    '/odisha-platform-landing', 
    '/odisha-service-landing',
    '/odisha-webdesign-landing'
  ];

  if (hiddenRoutes.some(route => location.pathname === route || location.pathname === `${route}/`)) {
    return null;
  }

  return <Header onGetStarted={onGetStarted} />;
}
